let _this;
let myPlayer;
import playVideo from './utmPlayVideo.vue'
import playVideoMore from './utmPlayVideoMore.vue'
import tag from './tag.vue'
import teleport from './utmTeleport.vue'
import SrsSdk from "../../assets/videojs/srs.sdk.js";
import DPlayer from 'dplayer';
import Hls from 'hls.js';
import esopTaskDetails from './esop-incident-task-details/index.vue'; //esop task详情弹窗
import utmFilesPanel from '../commonComponents/utm-files-panel/utm-files-panel.vue'
export default {
  name: 'message-detail-modal',
  components: {
    playVideo,
    playVideoMore,
    tag,
    teleport,
    esopTaskDetails,
    utmFilesPanel
  },
  data() {
    _this = this;
    return {
      departmentText: _this.ApiService.departmentText,
      messageModal: false,
      tabIndex: 0,
      messageInfo: {},
      totalCount: 0,
      /*消息内容*/
      file_base_url: window.g.API_UPLOAD_ROOT,//显示图片的路径
      loadTimer: '', /*加载更多计时器，避免频繁出发*/
      messageList: [], /*消息列表*/
      searchParam: {}, /*搜索参数*/
      totalPage: 0, /*总页数*/
      initEventId: '',/*初始消息id*/
      activeEventId: '',
      isMe: false,
      isAlarmMap: false, /*是否是所有alarm map的消息*/
      isAlarmMapByDevice: false, /*是否是alarm map的某个设备的消息*/
      pageSource: 0, /*页面来源，有的参数值说明在msgDetail事件处*/
      incidentCategory: '',
      /*播放视频*/
      videoTabIndex: 0,
      videoDeviceList: [],
      videoUrl: window.g.AVIGILON_ROOT,
      videoSrcUrl: '',


      /*事件处理Start*/
      processEventInfo: {
        processType: 0,
        note: ""
      },
      commentFalg: false,//备注是否填写
      //待处理事件列表
      titleData: [
        {type: 'checkbox', width: 45, align: 'left'},
        {
          title: 'Incident Name',
          minWidth: 170,
          slots: {default: 'name'},
        },
        {
          title: 'Description',
          minWidth: 260,
          slots: {default: 'content'},
        },
        {
          title: 'Created On',
          minWidth: 190,
          slots: {default: 'createTime'},
        },
        {
          title: 'Operation',
          width: 120,
          slots: {default: 'operation'},
        },
      ],
      taskTitleData: [
        {
          title: 'Incident Name',
          minWidth: 170,
          slots: {default: 'name'},
        },
        {
          title: 'Description',
          minWidth: 260,
          slots: {default: 'content'},
        },
        {
          title: 'Time',
          minWidth: 190,
          slots: {default: 'createTime'},
        },
        {
          title: 'Operation',
          width: 120,
          slots: {default: 'operation'},
        },
      ],
      processIncidentList: [], /*处理的事件消息列表*/
      checkedData: [],
      handleIncidentExpand: false,
      tableMaxHeight: 300,
      /*其它待处理事件详情信息*/
      tableItemDetailModal: false,
      tableItemInfo: {},
      hasVideoPermission: false,
      hasForwardPermission: false,
      hasReportPermission: true,

      showOpenBox:false,
      sipID:'',
      checkedAccessZone:[],//选择开门的点位
      checkedBarrierGateZone:[],//选择开道闸的点位
      accessZoneList:[],
      /******************************event monitoring 新增 start *********************************/
      isMonitorFlag:false,
      isFlexType:0,
      itemDetail:{},
      navIndex:0,
      handleDataList:[],
      isVideoType: 'Back',
      isArea: '',
      areaList: [{ id: '1', name: 'Event Area 1' }, { id: '1', name: 'Event Area 2Event Area 2Event Area 2Event Area 2Event Area 2Event Area 2' }],
      areaVideoList: [],
      eventDetailsModal: false,
      isShowArea: false,
      monitorIndex: 0,
      videoIndex: 0,
      downloadFileModal:false,
      downloadInfo: {
        name: '',
        startTime: 0,
        endTime: 0,
        cameraIds: []
      },
      openMonitoring:false,
      loadingCamera:true,
      watchVideoCode:'',
      isOpen: false,
      buildingName:'',
      orgDataList:[],
      showSetting:false,
      isVehicle:false,
      screenId:'',//实时视频camera全屏
      /**********************************event monitoring 新增 end *********************************/

      profileTabIndex:'',//当前的详情tab比如人，车辆，设备
      profileTabs:[],//人，车辆，等的切换tab
      incidentHistory:[],//esop历史记录
      roleObj:{},//获取的esop角色
      /******* Start 处理task任务处理弹窗 Start ******/
      taskDealWithModel: false,
      taskDealWithNoPwdModel: false,
      noAccount: false, // 是否有账号
      taskDealWithForm: {
        password: '',
        remarks: ''
      },
      resetPsdErrorFlag: false, //密码错误提示
      resetPsdErrorMsg: '', //密码错误提示信息
      submitStatus: false, // 处理成功
      /******* End 处理task任务处理弹窗 End ******/
      publicEncrypt: '',// 公钥

      /* 延迟处理弹窗 start */
      delayModel: false,
      delayForm: {
        day: 1,
        timer: '',
        delayTimespan: ''
      },
      delayTimes: [1, 2, 7, 14],
      // 自定义时间
      currentOptionsStart: {
        disabledDate(date) {
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            return date && date.valueOf() <= today.valueOf();
         }
      },
      vxeGridDisabled: false
      /* 延迟处理弹窗 end */
    }
  },
  mounted() {
    _this = this;
    /**
     * operateType: 操作类型. 0是详情. 1是播放视频. 2是处理消息
     * isMe: 是否是只查看自己的消息
     * pageSource: 进入来源页面,用于区分权限. 0或undefined是incident report. 1是消息中心. 2是即时推送消息. 3是My Incident. 4是Alarm Map. 5是Arming dashbaord;
     * 6是(未知，来自healthNotification.js的传值)
     * watchVideoCode 是否观看视频的权限
     */
    eventBus.$on('msgDetail', ((data, operateType, isMe, pageSource, isAlarmMap, isAlarmMapByDevice, incidentCategory,isMonitoring,watchVideoCode,isVehiclePort) => {
      this.watchVideoCode = watchVideoCode
      if(isVehiclePort){
        this.isVehicle=true;
      }else{
        this.isVehicle=false;
      }
      if(isMonitoring){
       // _this.openMonitoring=true;
      }else{
        console.log('noMonitoring');
        _this.openMonitoring=false;
      }
      if(operateType===1){
        _this.isMonitorFlag=true;
        _this.changeTab(5);
      }else{
        _this.isMonitorFlag=false;
      }
      _this.itemDetail=data;
      // 蜂窝过来的需要额外判断用户有没有处理权限 canHandle为处理权限
      if(typeof data.canHandle === 'boolean' && !data.canHandle){
        _this.itemDetail.canHandle = false
        isMe = false
      }else{
        _this.itemDetail.canHandle = true
      }
      _this.incidentCategory = typeof incidentCategory === 'number' ? incidentCategory : '';
      _this.messageList = [];
      _this.pageSource = pageSource;
      _this.processEventInfo = {
        processType: 0,
        note: ""
      };
      _this.commentFalg = false;
      _this.operateType = operateType;
      _this.isMe = isMe;
      _this.isAlarmMap = isAlarmMap;
      _this.isAlarmMapByDevice = isAlarmMapByDevice;
      _this.searchParam = {
        enabledPaging: true,
        isCurrentUser: false,
        page: 1,
        perPage: 10,
        sortName: "createTime",
        sortType: 1,
      };

      /** task start*/
      _this.taskDealWithModel = false
      _this.taskDealWithNoPwdModel = false
      _this.noAccount = false
      _this.taskDealWithForm = {
        password: '',
        remarks: ''
      }
      _this.resetPsdErrorFlag = false;
      _this.submitStatus = false;
      /** task end*/

      /* alarm map */
      if (isAlarmMap || isAlarmMapByDevice) {
        _this.searchParam.queryUnprocessedRecord = true;
      }
      if (isAlarmMapByDevice || pageSource === 5) { //根据设备id查
        _this.searchParam.deviceId = data.deviceId;
      }
      _this.initEventId = data.id || data.recordId;
      _this.activeEventId = _this.initEventId;
      if (pageSource === 5) { // Arming Dashboard
        _this.getArmingDeviceList(true);
      } else if (isAlarmMap || isAlarmMapByDevice) {
        // 查询alarm map
       // _this.getAlarmMapList(true);
      } else if (isMe) {
        _this.isMe = true;
        //_this.getMyMessageList();
      } else {
        //_this.getMessageList();
      }
      if (!isAlarmMapByDevice && pageSource !== 5) { // 不是根据设备筛选，查详情
        _this.getMessageDetail(0, operateType);
      }
      if(this.$root.isESOPMode){
        this.getIncidentHistory(data)
        this.$ajax.get('workflow/role/' +  window.g.ESOP_ROLE_SOURCE,{ baseURL: window.g.API_Flow}).then((res)=>{
          if(res.data.success && res.data.data.length > 0){
            let arr = res.data.data;
            arr.forEach((item)=>{
                this.roleObj[item.type] = item.name
            });
          }  
        })
      }
    }));
    eventBus.$on('closeMsgModal', () => {
      _this.messageModal = false;
    });
    _this.getPublicEncrypt();
  },
  beforeDestroy() {
   
    eventBus.$off('msgDetail');
    eventBus.$off('closeMsgModal');
  },
  watch: {
    "$root.contentHeight": {
      handler(nv) {
        if (_this.tabIndex === 2) {
          _this.getTableMaxHeight();
        }
      }
    }
  },
  computed: {
    sortDataList() {
      return this.handleDataList.slice().sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
  },
  methods: {
    // esop模式下的处理
    processMsg: function (row) {
        if(this.$root.isESOPMode){
        if(this.$route.path == '/incidentProcess'){
          if (this.$route.path == '/incidentProcess') {
            this.$router.replace({ path: '/empty' }).then(() => {
              this.$router.replace({ name: 'Process', params: { incident: JSON.stringify(row) } });
              this.messageModal = false;
            }).catch(() => {
              console.error('Failed to navigate to /empty');
            });
          }
        }else{
          this.$router.push({name:'Process',params:{incident:JSON.stringify(row)}})
          this.messageModal = false
        }
      }
    },
        // esop模式下 历史记录中打开task详情
    openTaskDetails(node){
      this.$refs.esopTaskDetail.open(this.messageInfo.id,{id:node.taskId});
    },
     // esop模式下 获取历史记录
    getIncidentHistory(data){
       this.$ajax.get('IncidentRecord/GetIncidentRecordHistory?incidentRecordId=' +  data.id).then((res)=>{
             if(res.data.success){
              this.incidentHistory = res.data.data.filter((item)=>{
                    return item.taskOperateType != 4 && item.taskOperateType != 5 && item.taskOperateType != 6 && item.taskOperateType != 7 
              });
              this.incidentHistory.forEach((item)=>{
                 if(item.extension){
                  item.extension = JSON.parse(item.extension)
                 }
              })
             }
       })
    },
    /********************************************event monitoring 新增 start*************************** */
    enterVideoItem(item){
      this.screenId=item.camera.id;
    },
    leaveVideoItem(item){
      this.screenId='';
    },
    screenChange(item){
      this.getCameraLiveUrl(this.fullCamera, 99);
    },
    handleAreaListData(list){
      return list.slice().sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    handlerIncidentStatus(status, isText) {
      const statusMap = {
          10: isText ? 'Notified' : 'notified',
          11: isText ? 'Processing' : 'processing',
          12: isText ? 'Closed' : 'closed',
          13: isText ? 'NA' : 'na',
          14: isText ? 'Read' : 'read',
          15: isText ? 'Unread' : 'unRead',
          16: isText ? 'Overtime' : 'overtime',
          17: isText ? 'Overtime Close' : 'overtimeClose'
      };
      return statusMap[status] || '-';
    },
    // 打开设备下拉列表
    openItem: function (e, map) {
      $(e.target)
        .parents(".area-list")
        .find(".area-list-box")
        .slideToggle();
      _this.isOpen = !_this.isOpen;
    },
    changeBackType(num){
      this.navIndex=num;
      if(num===1){
        this.areaVideoList = [];
        this.handleDataList=[];
        this.getVideoList();
      }
    },
    // 切换live  back
    changeVideoType(num) {
      this.monitorIndex = num;
      if (num === 1) {
        // 实时视频
        this.isVideoType = 'Live'
      } else {
        // 视频回放
        this.isVideoType = 'Back';
      }
      this.getVideoList();

    },
    toggleArea(area) {
      _this.disposePlayers(_this.areaVideoList);
      _this.isFlexType=area.videoNumber;
      this.areaVideoList = [];
      _this.handleVideoBox();
      this.isArea = area.id;
      area.cameras.findIndex(item => {
        if (item) {
          _this.$set(_this.areaVideoList[item.index], "id", item.id);
          _this.$set(_this.areaVideoList[item.index], "camera", item);
        }
      });
      if (this.isVideoType === 'Live'){
        this.createPlayer(area.cameras, 1, this.isVideoType);
      }else{
        area.cameras.forEach(item=>{
          _this.$set(item, "lowQuality", true);
          _this.getBackCameraUrl(item, item.index);
        })
      }
    },
    handleVideoBox() {
      for (let index = 0; index < _this.isFlexType; index++) {
        let obj = {
          id: 'init',
          camera: null
        }
        this.areaVideoList.push(obj);
      }
    },
    isFilterVideoList(){
      return _this.areaVideoList.filter(item => {
        return item.camera !== null;
      });
    },
    getVideoList(type) {
      _this.disposePlayers(_this.areaVideoList);
      let orgId=_this.itemDetail.id || _this.itemDetail.recordId;
      _this.$ajax.get("IncidentRecord/GetDetail?id=" + orgId).then(function (res) {
        if (res.data.success) {
          
          let devicesId = res.data.data.devices.map(item => item.deviceId)
          if (devicesId){
            _this.$ajax.post("ConcernArea/EventAreaByIds", devicesId).then(res => {
              if (res.data.success) {
                _this.orgDataList = res.data.data;
                _this.handleDataList = res.data.data[0].concernAreaDetailDto;
                _this.toggleArea(res.data.data[0].concernAreaDetailDto[0]);
              }
            })
          }
        }
      });
    },
    //销毁所有视频资源
    disposePlayers: function (data, type) {
      console.log('销毁',data);
      for (let camera of data) {
       if(camera.camera){
          if (camera.camera.backDp && this.tabMode !== -1) {
            camera.camera.backDp.destroy();
          }
          if (camera.camera.backHls) {
              camera.camera.backHls.destroy();
          }
          if (camera.camera.liveDp && this.tabMode !== -1) {
              camera.camera.liveDp.close();
          }
       }
    }
    },
    //创建视频资源
    createPlayer: function (data, type, videoType) {
      for (let camera of data) {
        _this.$set(camera, "lowQuality", true);
        if (videoType==='Live') {
          _this.getCameraLiveUrl(camera, type);
        } 
        else {
          _this.getBackCameraUrl(camera, type);
        }
      }
    },
    //首先根据设备的id获取视频的播放地址和token
    getBackCameraUrl: function (camera, type) {
      let lowQuality = camera.lowQuality;
      _this.loadingCamera=true;
      let time = this.messageInfo.triggerTime || this.messageInfo.createTime;
      _this.$set(camera, 'backUrl', null);
      _this.$ajax.get("Media/PlaybackAddress/" + camera.id + '?startTime=' + (time - 30000) + '&endTime=' + (time + 30000) + '&lowQuality=' + lowQuality, {
        headers: { noLoading: true },
        baseURL: window.g.VIDEO_ROOT
      })
        .then(res => {
          if (res.data.success) {
            _this.loadingCamera=false;
            let url = window.g.BACK_VIDEO_ROOT + 'playback/' + res.data.data.address + '.m3u8?token=' + res.data.data.token;
            camera.url = url;
            _this.$set(camera, 'backUrl', url);
            camera.dp = null;
            _this.$nextTick(() => {
              _this.playBackCamera(camera, type);
            });
          }
        });
    },
    getCameraLiveUrl: function (camera, type) {
      let lowQuality = camera.lowQuality;
      _this.loadingCamera=true;
      _this.$set(camera, 'liveUrl', null);
      _this.$ajax.get("Media/LiveAddress/" + camera.id + '?lowQuality=' + lowQuality, {
        headers: { noLoading: true },
        baseURL: window.g.VIDEO_ROOT
      })
        .then(res => {
          if (res.data.success) {
          _this.loadingCamera=false;

            let url = window.g.LIVE_VIDEO_ROOT + "live/" + res.data.data.address + "?token=" + res.data.data.token;
            camera.url = url;
            _this.$set(camera, 'liveUrl', url);
            camera.dp = null;
            _this.$nextTick(() => {
              _this.playLiveVideo(camera, type);
            });
          }
        });
    },
    playLiveVideo: function (video, type) {
      let startPlay = function () {
        $('#concernArea' + type + '_video' + video.index).show();
        if (video.dp) {
          video.dp.close();
        }
        video.dp = new SrsSdk.SrsRtcPlayerAsync();
        $('#concernArea' + type + '_video' + video.index).prop('srcObject', video.dp.stream);
        video.dp.ontrack = function (event) {
          video.dp.stream.addTrack(event.track);
        };
        video.dp.pc.onconnectionstatechange = function (event) {
        };
        let url = video.url;
        video.dp.play(url).then(function (session) {
        }).catch(function (reason) {
          video.dp.close();
          $('#concernArea' + type + '_video' + video.index).hide();
        });
      };
      $('#concernArea' + type + '_video' + video.index).prop('muted', false);
      startPlay();
    },
    playBackCamera: function (camera, index) {
      camera.backDp = new DPlayer({
        element: document.getElementById('playbackVideo' + index),
        lang: 'en',
        mutex: false,
        autoplay: true,
        loop: true,
        video: {
          url: camera.url,
          type: 'customHls',
          customType: {
            customHls: function (video, player) {
              if (camera.backHls) {
                camera.backHls.destroy();
              }
              camera.backHls = new Hls();
              camera.backHls.loadSource(video.src);
              camera.backHls.attachMedia(video);
            },
          },
          
        },
        contextmenu: [],
      });
      camera.backDp.on('notice_show', function (e) {
        let text = $(e).text()
        if ((text.indexOf("REW") > -1 || text.indexOf("FF") > -1)) {
          $(e).hide();
        }
      })
      camera.backDp.on('waiting', () => {
        //回放视频加载完成
        if (camera.backDp.video.duration > 59 && camera.backDp.video.currentTime > 59) {
          camera.backDp.pause();
          this.$emit('videoEnded', true);
        }
        return false;
      });
      camera.backDp.on('play', () => {
        //回放视频加载完成
        if (camera.backDp.video.currentTime > 59) {
          camera.backDp.seek(0);
        }
      });
      camera.backDp.on('fullscreen', (isFullScreen) => {
        if (!isFullScreen) {
            this.showSetting=true;
          }
    });
       camera.backDp.on('fullscreen_cancel', () => {
            this.showSetting=false;
     });
    },
    downLoadFile: function () {
      this.downloadInfo.cameraIds=[];
      let playbackTime = this.messageInfo.triggerTime || this.messageInfo.createTime
      let timeStr = this.moment((playbackTime - 30000), 'x').format('YYYYMMDDHHmmss');
      this.downloadInfo.name = 'Video' + timeStr;
      this.downloadInfo.startTime = playbackTime - 30000;
      this.downloadInfo.endTime = playbackTime + 30000;
      this.areaVideoList.forEach(item=>{
        if (item.camera){
          this.downloadInfo.cameraIds.push(item.id);
        }
      })
      this.downloadFileModal = true;
    },
    //确认下载视频
    confirmDownload: function () {
      let _this = this;
      _this.$validator.validateAll('downloadInfo').then(result => {
        if (result) {
          _this.$ajax.post('VideoRecord/Create', _this.downloadInfo).then(function (res) {
            if (res.data.success) {
              _this.messageNotice("success");
              _this.downloadFileModal = false;
            } else {
              _this.messageNotice("error", res.data.message);
            }
          });
        }
      });
    },
    /********************************************event monitoring 新增 end******************************* */

    //切换tab标签
    changeTab: function (index) {
      console.log('标签',index);
      _this.tabIndex = index;
      if (index === 2) {
        _this.commentFalg = false;
        _this.processEventInfo = {
          processType: 0,
          note: ""
        };
        _this.getProcessIncidentList();
      } else if (index === 1) {
        this.changeBackType(0)
        _this.videoTabIndex = 1;
        _this.$nextTick(() => {
          _this.$refs.messageVideo.changeVideoDevice(_this.videoDeviceList[0], _this.messageInfo.createTime);
        })
      }else if(index === 5){
        this.changeBackType(0)
      }else if(index === 6){
        this.changeBackType(1)
        this.changeVideoType(0)
      }
    },
    // 获取权限
    getMsgPermission: function (result) {
      let privateCode = "",
        publicCode = "",
        forwardCode = "",
        videoCode = '',
        usableReportTypes = [];
      let pageSource = _this.pageSource;
      let category = result.incidentCategory;
      if (pageSource === 1 || pageSource === 2 || pageSource === 3 || pageSource === 4) {
        let publicMap = {
          0: 'M_GeneratePublicMyAlarmReport',
          1: 'M_GeneratePublicMyNotificationReport',
          2: 'M_GeneratePublicMyTaskReport',
        };
        let privateMap = {
          0: 'M_GeneratePrivateMyAlarmReport',
          1: 'M_GeneratePrivateMyNotificationReport',
          2: 'M_GeneratePrivateMyTaskReport',
        };
        let videoMap = {
          0: 'M_ViewMyAlarmVideo',
          1: 'M_ViewMyNotificationVideo',
          2: 'M_ViewMyTaskVideo',
        };
        let forwardMap = {
          0: 'M_ForwardAlarm',
          1: 'M_ForwardNotification',
          2: 'M_ForwardTask',
        };
        publicCode = publicMap[category];
        privateCode = privateMap[category];
        videoCode = videoMap[category];
        forwardCode = forwardMap[category];
      } else {
        let publicMap = {
          0: 'M_GeneratePublicIncidentReport',
          1: 'M_GeneratePublicIncidentNotificationReport',
          2: 'M_GeneratePublicIncidentTasksReport',
        };
        let privateMap = {
          0: 'M_GeneratePrivateIncidentReport',
          1: 'M_GeneratePrivateIncidentNotificationReport',
          2: 'M_GeneratePrivateIncidentTasksReport',
        };
        let videoMap = {
          0: 'M_ViewIncidentVideo',
          1: 'M_ViewIncidentNotificationVideo',
          2: 'M_ViewIncidentTasksVideo',
        };
        let forwardMap = {
          0: '',
          1: '',
          2: '',
        };
        publicCode = publicMap[category];
        privateCode = privateMap[category];
        videoCode = videoMap[category];
        forwardCode = forwardMap[category];
      }

      if (!publicCode) {
        usableReportTypes = [0, 1];
      } else {
        if (_this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf(publicCode) > -1) {
          usableReportTypes.push(0);
        }
        if (_this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf(privateCode) > -1) {
          usableReportTypes.push(1);
        }
      }

      if (videoCode && _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf(videoCode) > -1) {
        _this.hasVideoPermission = true;
      } else {
        _this.hasVideoPermission = false;
      }
      if (forwardCode && _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf(forwardCode) > -1) {
        _this.hasForwardPermission = true;
      } else {
        _this.hasForwardPermission = false;
      }
      if (usableReportTypes.length) {
        _this.hasReportPermission = true;
      } else {
        _this.hasReportPermission = false;
      }
    },
    // 查询消息列表
    getMessageList: function (callback) {
      let params = JSON.parse(JSON.stringify(_this.searchParam));
      if (typeof _this.incidentCategory === 'number') {
        params.category = _this.incidentCategory;
      }
      _this.$ajax.post('IncidentRecord/Paginate', params, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success && res.data.data.items.length > 0) {
          _this.totalCount = res.data.data.pageCount;
          let newData = res.data.data.items;
          /*判断当前列表中是否出现第一次进入时的那条消息，用于避免列表出现两条相同的消息*/
          let index = newData.findIndex(item => {
            return item.id === _this.initEventId;
          });
          if (index > -1) {
            newData.splice(index, 1);
          }
          _this.messageList = _this.messageList.concat(newData);
          _this.searchParam.page++;
        }
      })
    },
    getMyMessageList: function (callback) {
      let params = JSON.parse(JSON.stringify(_this.searchParam));
      if (typeof _this.incidentCategory === 'number') {
        params.category = _this.incidentCategory;
      }
      _this.$ajax.post('IncidentRecord/PaginateMyself', params, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success && res.data.data.items.length > 0) {
          _this.totalCount = res.data.data.pageCount;
          let newData = res.data.data.items;
          /*判断当前列表中是否出现第一次进入时的那条消息，用于避免列表出现两条相同的消息*/
          let index = newData.findIndex(item => {
            return item.id === _this.initEventId;
          });
          if (index > -1) {
            newData.splice(index, 1);
          }
          _this.messageList = _this.messageList.concat(newData);
          _this.searchParam.page++;
        }
      })
    },
    // Arming Dashboard 查设备
    getArmingDeviceList: function (isInited, callback) {
      if(_this.searchParam.deviceId){
        _this.searchParam.statuses = [10,11]
      }
      _this.$ajax.post('IncidentRecord/Paginate', _this.searchParam, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success && res.data.data.items.length > 0) {
          _this.totalCount = res.data.data.pageCount;
          let newData = res.data.data.items;
          if (newData.length > 0 && isInited) {
            _this.initEventId = newData[0].recordId;
            _this.getMessageDetail(0, 0, newData[0]);
          }
          // 判断当前列表中是否出现第一次进入时的那条消息，用于避免列表出现两条相同的消息
          let index = newData.findIndex(item => {
            return item.recordId === _this.initEventId;
          });
          if (index > -1 && _this.initEventId) {
            newData.splice(index, 1);
          }
          // 更新消息列表
          _this.messageList = _this.messageList.concat(newData);
          _this.searchParam.page++;
        } else {
          _this.messageNotice('error', 'No alarm information');
        }
      })
    },
    // 获取 alarm map 的消息记录
    getAlarmMapList: function (isInited, callback) {
      _this.$ajax.post('AlarmMap/PagingMapPendingTask', _this.searchParam, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success && res.data.data.items.length > 0) {
          _this.totalCount = res.data.data.pageCount;
          let newData = res.data.data.items;
          if (_this.isAlarmMapByDevice && newData.length > 0 && isInited) {
            _this.initEventId = newData[0].recordId;
            _this.getMessageDetail(0, 0, newData[0]);
          }
          // 判断当前列表中是否出现第一次进入时的那条消息，用于避免列表出现两条相同的消息
          let index = newData.findIndex(item => {
            return item.recordId === _this.initEventId;
          });
          if (index > -1) {
            newData.splice(index, 1);
          }
          // 更新消息列表
          _this.messageList = _this.messageList.concat(newData);
          _this.searchParam.page++;
        } else {
          _this.messageNotice('error', 'No alarm information');
        }
      })
    },

    // 切换消息详情
    getMessageDetail: function (index, operateType, msg) {
      if (myPlayer) {
        myPlayer.dispose();
        myPlayer = null;
        console.log("destroy")
      }
      if (msg) {
        _this.activeEventId = msg.id || msg.recordId;
      }
      _this.handleIncidentExpand = false;
      if(!_this.isMonitorFlag){
        _this.tabIndex = operateType;
      }
      _this.videoDeviceList = [];
      _this.videoTabIndex = 1;
      _this.shareApi.getMsgDetailById(_this.activeEventId).done(result => {
        _this.messageModal = true;
        console.log(_this.messageModal)

        _this.messageInfo = result;
        _this.messageInfo.index = index;
        _this.getMsgPermission(result); // 获取处理转发查看视频等权限
        if ((_this.initEventId === _this.activeEventId && _this.messageList.length > 0 && _this.messageList[0].id !== _this.initEventId) || _this.messageList.length === 0) {
          _this.messageList.unshift(_this.messageInfo);
        }
        //判断消息是否已读
        if(_this.messageInfo.status == 15) {
          // 判断当前登录人是否为接收人
          _this.$ajax.get('IncidentRecord/VerifyCurrentUserIsRecipient?id='+ _this.activeEventId, { headers: { noLoading: true } }).then(res => {
            if(res.data.data || _this.isMe){
              _this.setMessageRead(_this.messageInfo);
            }
          })
        }
        if (_this.messageList.length > index && _this.isMe) {
          _this.$set(_this.messageList[index], 'isRead', true);
        }
        _this.dynamicSwitch();

        //获取设备地图图片
        if(_this.messageInfo.devices && _this.messageInfo.devices.length > 0){
          _this.getAccessZones()
          _this.messageInfo.devices.forEach(device => {
            if (device.mapFileId) {
              _this.shareApi.getImgUrl(device.mapFileId).done((img) => {
                _this.$set(device, "mapUrl", img);
              });
              let w = device.mapWidth;
              let h = device.mapHeight;
              let conW = 255;
              let conH = 143;
              let val1 = w / h;
              let val2 = conW / conH;
              if (val1 > val2) {
                _this.$set(device, "mapWidthStr", conW);
                _this.$set(device, "mapHeightStr", conW * h / w);
              } else {
                _this.$set(device, "mapWidthStr", conH * w / h);
                _this.$set(device, "mapHeightStr", conH);
              }
            }
          });
          _this.videoDeviceList = _this.messageInfo.devices.filter((device) => {
            return device.canPlayBackVideo;
          });
        }
        //将普通模式下的转发合并,因为之前的转发是转发10个就有10个历史记录,现在就是将这写历史记录合并为一个
        let operatorHistories =  _this.messageInfo.operatorHistories
        const mergedData = operatorHistories.reduce((acc, item) => {
          // 使用 lastUpdateTime 作为键来合并具有相同时间戳的对象
          const key = item.lastUpdateTime;
      
          if (!acc[key]) {
              // 如果还没有这个时间戳的键，创建一个新对象
              acc[key] = { ...item, forwardReceiverNames: [item.forwardReceiverName] };
          } else {
              // 如果已经有这个时间戳的键，添加 forwardReceiverName 到数组中
              acc[key].forwardReceiverNames.push(item.forwardReceiverName);
          }
      
          return acc;
      }, {});
         _this.messageInfo.operatorHistories = Object.values(mergedData);
        //是否存在扩展信息
        if (_this.messageInfo.extension && _this.messageInfo.extension !== '{}') {
          _this.messageInfo.extension = JSON.parse(_this.messageInfo.extension);
        } else {
          _this.messageInfo.extension = null;
        }
        // 处理历史记录扩展信息
        _this.messageInfo.operatorHistories = _this.messageInfo.operatorHistories.map(op => {
          if(op.extension) {
            op.extension = JSON.parse(op.extension);
          } else {
            op.extension = null;
          }
          return op;
        })
        // 如果入口是消息通知的播放回放视频按钮，切换到该部分
        if (operateType === 1) {
          if (_this.videoDeviceList.length > 0) {
            _this.$nextTick(() => {
              _this.$refs.messageVideo.changeVideoDevice(_this.videoDeviceList[0]);
            })
          }
        } else if (operateType === 2) {//处理消息
          _this.getProcessIncidentList();
        }
        // 组装profile tab
        _this.profileTabs = [];
        let device = _this.messageInfo.devices
        if(device) {
          device = _this.messageInfo.devices.filter(r=> r.isMainDevice)
        }
        if(device && device.length > 0){
          _this.profileTabs.push('Device Profile')
        }
        if(_this.messageInfo.users  && _this.messageInfo.users.length > 0){
          _this.profileTabs.push('User Profile')
        }
        if(_this.messageInfo.vehicles  && _this.messageInfo.vehicles.length > 0){
          _this.profileTabs.push('Vehicle Profile')
        }
        if(_this.messageInfo.incidentType === 6001 && _this.messageInfo.extension){
          _this.profileTabs.push('Account Profile')
        }
        _this.profileTabIndex = _this.profileTabs[0]
      }).fail((error) => {
        _this.messageNotice('error', error);
        _this.messageInfo = {};
      });
    },
    // 选中项始终在可视范围
    dynamicSwitch: function () {
      $('#message-list').scrollLeft(225 * _this.messageInfo.index);
    },

    //消息横向拖动加载数据
    handleMsgListScroll: function () {
      let dom = $('#message-list')[0];
      clearTimeout(_this.loadTimer);
      if (dom.scrollLeft >= dom.scrollWidth - dom.offsetWidth) {
        _this.loadTimer = setTimeout(function () {
          if (_this.searchParam.page < _this.totalCount) {
            if (_this.isAlarmMap || _this.isAlarmMapByDevice) {
              // 查询alarm map
              _this.getAlarmMapList();
            } else if (_this.isMe) {
              _this.getMyMessageList();
            } else {
              _this.getMessageList();
            }
          } else {
            _this.messageNotice('info', 'It\'s the end of it');
          }
        }, 300)
      }
    },
    // 切换消息
    changeMessage: function (type) {
      /*上一条*/
      if (myPlayer) {
        myPlayer.dispose();
        myPlayer = null;
        console.log("destroy3")
      }
      _this.tabIndex = 0;
      if (type === 0) {
        if (_this.messageInfo.index > 0) {
          _this.getMessageDetail(_this.messageInfo.index - 1, 0, _this.messageList[(_this.messageInfo.index - 1)]);
        }
      } else if (_this.messageInfo.index < _this.messageList.length - 1){
        _this.getMessageDetail(_this.messageInfo.index + 1, 0, _this.messageList[(_this.messageInfo.index + 1)]);
      } else if (_this.messageInfo.index === _this.messageList.length - 1) { /*加载到最后一条时，更新列表数据*/
        if (_this.isAlarmMap || _this.isAlarmMapByDevice) {
          _this.getAlarmMapList();
        } else if (_this.isMe) {
          _this.isMe = true;
          _this.getMyMessageList();
        } else {
          _this.getMessageList();
        }
      }
    },

    /*消息的其他操作*/
    // 消息转发
    forwardMsg: function () {
      // ESOP模式下，转发Notification和Task，都不需要Operational Role字段
      if(this.$root.isESOPMode && (_this.messageInfo.incidentCategory === 2 || _this.messageInfo.incidentCategory === 1)) {
        eventBus.$emit('forwardMsg', _this.messageInfo.id, false)
      }else {
        eventBus.$emit('forwardMsg', _this.messageInfo.id)
      }
      
    },
    //生成报表
    generateMessage: function () {
      eventBus.$emit('reportGeneration',
        [{ id: _this.messageInfo.id, uniqueId: _this.messageInfo.uniqueId, incidentName: _this.messageInfo.incidentName, cameraSourceIds: _this.messageInfo.cameraSourceIds }],
        1,
        { searchInfo: [] },
        {},
        true,
        _this.pageSource,
        _this.messageInfo.incidentCategory
      );
    },
    //设置消息为已读
    setMessageRead: function (msg) {
      this.$ajax.post('IncidentRecord/Read', { ids: [msg.id] },{ headers: { noLoading: true } }).then(function (res) {
        if (res.data.success) {
          eventBus.$emit('updateMsgList', msg.id);
          /* 关闭不需要处理已读的消息的音频 */
          if (msg.handleType === 0) {
            eventBus.$emit('closeMsgAudio', [msg.id]);
          }
          /* 关闭不需要处理已读的消息的音频 end*/
          _this.$root.getUnreadMessage();
        }
      })
    },
    openRecordDesc: function (e) {
      $(e.target).toggleClass('utm-collapse-note');
      $(e.target).parent('.processing-records-content').siblings('.processing-records-remark').slideToggle();
    },


    /*************************************事件处理Start********************************************/
    // 获取处理事件列表
    getProcessIncidentList: function () {
      _this.checkedData = [];
      _this.processEventInfo.processType = 0;
      _this.processEventInfo.note = "";
      if (_this.messageInfo.duplicateCondition) {
        _this.$ajax.post('IncidentRecord/GetDuplicates', { duplicateCondition: _this.messageInfo.duplicateCondition, type: _this.messageInfo.incidentType,enabledPaging:false,enabledPageCount:false }).then(function (res) {
          if (res.data.success) {
            let dataArr = res.data.data.items.filter((evtItem) => {
              return typeof evtItem.processType !== "number" && evtItem.id !== _this.messageInfo.id;
            });
            dataArr.unshift(_this.getCurIncidentObj());
            dataArr.forEach((item) => {
              if (!item.content) {
                item.content = "-";
              }
            });
            _this.processIncidentList = dataArr;
          } else {
            _this.processIncidentList = [_this.getCurIncidentObj()];
            _this.messageNotice('error', res.data.message);
          }
        }).catch(() => {
          _this.processIncidentList = [_this.getCurIncidentObj()];
        });
        _this.getTableMaxHeight();
      } else {
        _this.processIncidentList = [_this.getCurIncidentObj()];
      }
    },
    // 把当前事件加入事件列表
    getCurIncidentObj: function () {
      _this.vxeGridDisabled = false;
      if (_this.messageInfo) {
        _this.checkedData = [_this.messageInfo.id];
        let curMsgObj = JSON.parse(JSON.stringify(_this.messageInfo));
        curMsgObj.checked = true;
        curMsgObj.disabled = true;
        _this.$nextTick(() => {
          _this.$refs.vxeGrid.setCheckboxRow([curMsgObj], true);
          setTimeout(() => {
            _this.vxeGridDisabled = true;
          },300)
        })
        return curMsgObj;
      }
    },
    checkDisabled({ row }) {
      if(!_this.vxeGridDisabled) {
        return true;
      }else  {
        // 根据具体条件判断是否禁用复选框
        return _this.messageInfo.id !== row.id;
      }
    },
    // 获取表格最大高度
    getTableMaxHeight: function () {
      let height = $(".tab-content").height();
      _this.tableMaxHeight = Math.max(90, height - 390);
    },

    //发送事件处理
    submitProcessMessage: function (isReadOnly) {
      if (!isReadOnly) {
        if (_this.processEventInfo.processType === 0 && !_this.processEventInfo.note) {
          _this.commentFalg = true;
          return;
        }
      } else {
        _this.commentFalg = false;
      }
      let array = _this.checkedData.map(value => {
        return { id: value, processType: isReadOnly ? 2 : _this.processEventInfo.processType, note: _this.processEventInfo.note }
      });
      this.$ajax.post('IncidentRecord/Process', array).then(function (res) {
        if (res.data.success) {
          _this.messageNotice('success');
          _this.messageModal = false;
          eventBus.$emit('updateMsgList');

          /* 关闭需要处理处理过的消息的音频 */
          let msgIds = _this.checkedData;
          eventBus.$emit('closeMsgAudio', msgIds);
          /* 关闭需要处理处理过的消息的音频 end */
          _this.$root.getUnreadMessage();
        } else {
          _this.messageNotice('error', res.data.message);
        }
      })
    },
    // 批量选中
    getCheckData: function (row) {
      const data = row.records
      _this.checkedData = [];
      if (data.length > 0) {
        data.forEach(item => {
          _this.checkedData.push(item.id);
        });
      }
    },
    // 查看表格中的详情
    viewTableItemDetail: function (msg) {
      _this.tableItemInfo = {};
      _this.shareApi.getMsgDetailById(msg.id).done(result => {
        _this.tableItemInfo = result;
        _this.tableItemDetailModal = true;
        //获取设备地图图片
        if (_this.tableItemInfo.devices && _this.tableItemInfo.devices.length > 0) {
          _this.tableItemInfo.devices.forEach(device => {
            if (device.mapFileId) {
              _this.shareApi.getImgUrl(device.mapFileId).done((img) => {
                _this.$set(device, "mapUrl", img);
              });
              let w = device.mapWidth;
              let h = device.mapHeight;
              let conW = 255;
              let conH = 143;
              let val1 = w / h;
              let val2 = conW / conH;
              if (val1 > val2) {
                _this.$set(device, "mapWidthStr", conW);
                _this.$set(device, "mapHeightStr", conW * h / w);
              } else {
                _this.$set(device, "mapWidthStr", conH * w / h);
                _this.$set(device, "mapHeightStr", conH);
              }
            }
          });
        }
        //是否存在扩展信息
        if (_this.tableItemInfo.extension && _this.tableItemInfo.extension !== '{}') {
          _this.tableItemInfo.extension = JSON.parse(_this.tableItemInfo.extension);
        } else {
          _this.tableItemInfo.extension = null;
        }
        if (!msg.isRead && _this.isMe) {
          _this.setMessageRead(msg);
        }
      }).fail((error) => {
        _this.messageNotice('error', error);
      });
    },
    closeMessageModal: function () {
      if (myPlayer) {
        myPlayer.dispose();
        myPlayer = null;
        console.log("destroy4")
      }
      _this.disposePlayers(_this.areaVideoList);
      _this.messageModal = false;
      _this.showOpenBox = false;
    },
    //Track and Trace跳转
    goFaceTracking: function (user) {
      _this.tableItemDetailModal = false;
      _this.closeMessageModal();
      if (user.userFace) {
        if (_this.$route.name !== "Track and Trace") {
          _this.$router.push({
            name: "Track and Trace", params: {
              face: user.userFace
            }
          })
        } else {
          eventBus.$emit('trackAndTrace', { face: user.userFace });
        }
      } else if (user.userFaceId) {
        _this.shareApi.getImgUrl(user.userFaceId).done((result) => {
          if (result) {
            if (_this.$route.name !== "Track and Trace") {
              _this.$router.push({
                name: "Track and Trace", params: {
                  face: result
                }
              })
            } else {
              eventBus.$emit('trackAndTrace', { face: result });
            }
          } else if (_this.$route.name !== "Track and Trace") {
            _this.$router.push({
              name: "Track and Trace", 
              params: {
                userName: user.userName
              }
            })
          } else {
            eventBus.$emit('trackAndTrace', { userName: user.userName });
          }
        }).fail((err) => {
          if (_this.$route.name !== "Track and Trace") {
            _this.$router.push({
              name: "Track and Trace", params: {
                userName: user.userName
              }
            })
          } else {
            eventBus.$emit('trackAndTrace', { userName: user.userName });
          }
        })
      } else if (_this.$route.name !== "Track and Trace") {
        _this.$router.push({
          name: "Track and Trace", 
          params: {
            userName: user.userName
          }
        })
      } else {
        eventBus.$emit('trackAndTrace', { userName: user.userName });
      }
    },
    getAccessZones(){
      let _this = this;
      let sipDeviceId
      for(const item of _this.messageInfo.devices) {
        if(item.deviceType === 0) {
          sipDeviceId = item.deviceId;
          break;
        }
      }
      if(!sipDeviceId){
        return;
      }
      console.log('_this.messageInfo',_this.messageInfo,sipDeviceId)
      this.$ajax.get('AccessZone/GetBySipDeviceId/' + sipDeviceId,{headers:{noLoading:true}}).then(res =>{
          if(res.data.success){
              _this.accessZoneList = res.data.data;
          }else{
              _this.accessZoneList = [];
          }
      })
    },
    //选择开门点位
    checkDoor(door) {
      console.log('door',door)
      let index
      if(door.type === 1) {
        index = this.checkedAccessZone.findIndex(id => door.id === id);
        if (index > -1) {
            this.checkedAccessZone.splice(index, 1);
        } else {
            this.checkedAccessZone.push(door.id)
        }
      }
      if(door.type === 2) {
        index = this.checkedBarrierGateZone.findIndex(id => door.id === id);
        if (index > -1) {
            this.checkedBarrierGateZone.splice(index, 1);
        } else {
            this.checkedBarrierGateZone.push(door.id)
        }
      }
    },
    /* *************************远程开门的相关逻辑******************* */
    //确认开门
    openDoor:function(){
      let _this = this;
      if(_this.accessZoneList.length > 0) {
        if(_this.checkedAccessZone.length === 0 && _this.checkedBarrierGateZone.length === 0){
          _this.messageNotice('error','Please select door or barrier gate');
          return;
        }
        if(_this.checkedAccessZone.length) {
          let openDoorParams = { accessZoneIds: _this.checkedAccessZone, controlType: 0};
          this.$ajax.post('DoorAccessControl/RemoteControlDoor', openDoorParams).then(res => {
              if (res.data.success) {
                  _this.messageNotice('success');
              }
          })
        }
        if(_this.checkedBarrierGateZone.length) {
          let openBarrierGateParams = { accessZoneIds: _this.checkedBarrierGateZone, controlType: 0};
          this.$ajax.post('DoorAccessControl/BatchRemoteControlBarrierGate', openBarrierGateParams).then(res => {
              if (res.data.success) {
                  _this.messageNotice('success');
              }
          })
        }
      } else {
        _this.showOpenBox = false;
      }
    },

    /** 附件下载 */
    downloadFile(file){
      _this.shareApi.getFileContent(file);
    },

    /***Start task处理弹窗事件 ***/
    taskModelClose:function(){
      _this.noAccount = false
      _this.taskDealWithForm = {
        password: '',
        remarks: ''
      }
      _this.resetPsdErrorFlag = false;
      _this.submitStatus = false;
      _this.taskDealWithModel = false
      _this.taskDealWithNoPwdModel = false
    },
    pwdModelClose:function(){
      _this.taskModelClose();
      _this.tabIndex = 0;
    },
    getPublicEncrypt:function(){
      this.$ajax.get('Encryption/GetRSAPublicKey').then(function (res) {
        if (res.data.success) {
          _this.publicEncrypt = res.data.data;
        } else {
          _this.publicEncrypt = '';
        }
      })
    },
    taskDealWithSubmit:function() {
      _this.$validator.validateAll('taskDealWithForm').then(result =>{
        if(result){
          // 处理密码
          if(_this.messageInfo.incidentType == '9001'){
            let encrypt = new _this.jsEncrypt();
            encrypt.setPublicKey(_this.publicEncrypt);
            // 密码修改
            let pwd = encrypt.encrypt(_this.common.generateRandomPassword());
            const taskDealWithForm = {
              id: _this.messageInfo.extension.accountId,
              oldPassword: encrypt.encrypt(_this.taskDealWithForm.password),
              password: pwd,
              confirmPassword: pwd,
            }
            _this.$ajax.post('Account/ChangePassword', taskDealWithForm).then(res => {
              if (res.data.success) {
                _this.processTask(false);
              } else {
                _this.resetPsdErrorFlag = true;
                _this.resetPsdErrorMsg = res.data.message;
              }
            })
          }else { // 其他类型处理
            _this.processTask(true);
          }
        }
      })
    },
    taskSubmitProcessMessage(){
      // 密码修改验证密码是否存在
      if(_this.messageInfo.incidentType == '9001'){
        let accountId = ''
        const extension = _this.messageInfo.extension
        accountId = extension.accountId
        _this.$ajax.get('Account/IsAccountExisted?accountId=' + accountId).then(function (res) {
          if (res.data.data) {
            _this.taskDealWithModel = true
            _this.noAccount = true
          } else {
            _this.taskDealWithNoPwdModel = true
            _this.noAccount = false
          }
        })
      }
    },
    // 处理task isRemark 是否是非密码处理 \ noAccount 是否是账号不存在的处理
    processTask(isRemark, noAccount = false){
      const taskDealWithForm = {
        incidentRecordId: _this.messageInfo.id,
      }
      if(isRemark){
        taskDealWithForm.remark = _this.taskDealWithForm.remarks
      }
      _this.$ajax.post('IncidentRecord/ProcessTask', taskDealWithForm).then(res => {
        if (res.data.success) {
          if(isRemark) {
            _this.pwdModelClose();
          }else {
            _this.submitStatus = true;
            // 关闭详情弹窗
            _this.closeMessageModal();
            eventBus.$emit('updateMsgList', _this.messageInfo.id);
          }
          if(noAccount){
            _this.taskDealWithNoPwdModel = false;
          }
          _this.messageNotice('success');
        } else {
          _this.messageNotice('error', res.data.message);
        }
      })
    },
    // task 不能被重复处理
    processPermission(){
      let flag = true;
      if(_this.messageInfo.incidentCategory === 2 && (_this.messageInfo.status === 12 || _this.messageInfo.status === 17)){
        flag = false;
      }
      if(_this.messageInfo.incidentCategory === 0 && this.$root.isESOPMode){
        flag = false
      }
      return flag;
    },
    
    // 延迟处理弹窗操作事件
    delayHandle:function(){
      _this.delayForm.incidentRecordId = _this.messageInfo.id;
      _this.delayModel = true
    },
    // 延迟处理弹窗关闭事件
    delayModelClose:function(){
      _this.delayForm = {
        day: 1,
        timer: '',
        delayTimespan: ''
      }
      _this.delayModel = false
    },
    // 延期提交事件
    delaySubmit:function() {
      _this.$validator.validateAll('delayForm').then(result =>{
        if(result){
          const params = {
            incidentRecordId: _this.delayForm.incidentRecordId
          }
          if(_this.delayForm.day === 'Customize') {
            const currentTimestamp = Date.now(); // 获取当前时间的时间戳
            const startOfDayTimestamp = new Date().setHours(0, 0, 0, 0); // 获取今天零点的时间戳
            const timeElapsed = currentTimestamp - startOfDayTimestamp; // 获取当前时间0点到现在的时间差（时间戳）
            params.delayTimespan = _this.delayForm.delayTimespan + timeElapsed
          }else {
            params.delayDays = _this.delayForm.day
          }
          // 发送延期请求
          this.$ajax.post('IncidentRecord/DelayTask', params).then((res)=>{
            if (res.data.success) {
              this.messageNotice("success");
              _this.delayModelClose()
              this.getMessageDetail(0, 0, undefined);
              eventBus.$emit('updateMsgList', _this.messageInfo.id);
            }else{
              this.messageNotice("error", res.data.message)
            }
          })
        }
      })
    },
    datePickerChange(e){
      const dateStr = e;
      const [day, month, year] = dateStr.split('-').map(Number);
      const timestamp = new Date(year, month - 1, day).getTime();
      this.delayForm.delayTimespan = timestamp;
      this.delayForm.timer = e;
    },
    // 获取事件类型的文本
    incidentCategoryText(capital = false) {
      let category;
      if (this.incidentCategory === 0) {
        category = 'alarm';
      } else if (this.incidentCategory === 1) {
        category = 'notification';
      } else {
        category = 'task';
      }
      if (capital) {
        category = category.charAt(0).toUpperCase() + category.slice(1);
      }
      return category;
    },
    /***End task处理弹窗事件 ***/
    // 预览附件
    viewAttachment (item) {
      let url = null;
      if (item.fileId) {
        url = _this.$root.fileBaseUrl + 'Files/Get/' + item.fileId + '?access_token=' + _this.ApiService.accessToken.substr(7);
      } else if (item.fileData) {
        url = item.imgBase64Type + item.fileData;
      }
      if (item.type === 1) {
        _this.videoModal = true;
        _this.$nextTick(() => {
          _this.$refs.messageVideo.palyVideoUrl(url);
        })
      } else if (item.type === 2) {
        if (_this.audioWrapper) {
          _this.audioWrapper.pause();
          _this.audioWrapper.load();
          _this.audioWrapper.src = url;
          _this.audioSchedule = 0;
          _this.audioWrapper.play();
          _this.audioFlag = true;
          _this.audioWrapper.addEventListener('ended', function () {
            _this.audioFlag = false;
          }, false);
          _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
            //用秒数来显示当前播放进度
            _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
          }, false);
        } else {
          _this.audioWrapper = new Audio(url);
          _this.audioSchedule = 0;
          _this.audioWrapper.play();
          _this.audioFlag = true;
          _this.audioWrapper.addEventListener('ended', function () {
            _this.audioFlag = false;
          }, false);
          _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
            //用秒数来显示当前播放进度
            _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
          }, false);
        }
      } else if (item.type === 0) {
        _this.$root.viewBigImg(url);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/messageDetailModal.js